import CreatableComponent from "../../ui/create/CreatableComponent";
import Email from "../../../model/email/Email";

export default class MailMultiSelector extends CreatableComponent<Email> {
	elementToText(email: Email) {
		return email.value;
	}
}
